var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "Row",
        [
          _c(
            "Col",
            { attrs: { span: "3" } },
            [
              _c(
                "Content",
                { style: { height: _vm.maxHeight } },
                [
                  _c(
                    "el-table",
                    {
                      ref: "table",
                      attrs: {
                        data: _vm.packagesList,
                        "highlight-current-row": "",
                        "highlight-selection-row": "",
                        "show-header": false,
                        "max-height": _vm.maxHeight,
                        "row-class-name": _vm.tableRowClassName,
                      },
                      on: { "row-click": _vm.handleRowClick },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          fixed: "",
                          prop: "name",
                          "show-overflow-tooltip": "",
                          "max-width": "50",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "Col",
            { attrs: { span: "21" } },
            [
              _vm.queryProjectsData && _vm.queryProjectsData.length > 0
                ? _c("RequiredManageField", {
                    ref: "screeningFormList",
                    style: {
                      "max-height": _vm.maxHeight,
                      "overflow-y": "auto",
                      "box-sizing": "border-box",
                    },
                    attrs: { queryProjectsData: _vm.queryProjectsData },
                    on: {
                      "update:queryProjectsData": function ($event) {
                        _vm.queryProjectsData = $event
                      },
                      "update:query-projects-data": function ($event) {
                        _vm.queryProjectsData = $event
                      },
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }